import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-charts',
    templateUrl: './charts.component.html',
    styleUrls: ['./charts.component.scss'],
    standalone: false
})
export class ChartsComponent implements OnInit {

  constructor() { 
    // This is intentional
  }

  ngOnInit(): void {
    // This is intentional
  }

}
